<div class="page">
  <div class="page__container">
    <h1 class="page__title h2 mb-5">{{ 'sms_textarea' | translate }}</h1>

    <div class="my-5">
      <wsb-sms-textarea>

      </wsb-sms-textarea>
    </div>
  </div>
</div>
